const mapClientIdByHostname: Record<string, string> = {
  'preprod-field-service-app.revers.io': 'preprod-field-service-app.revers.io',
  localhost: 'preprod-field-service-app.revers.io',
};

const AuthConfiguration = {
  authority: 'https://preprod-app-login.revers.io',
  clientId: 'preprod-field-service-app.revers.io',
  scope: 'openid email api',
};

const { hostname } = window.location;

AuthConfiguration.clientId =
  mapClientIdByHostname[hostname] || window.location.hostname;

export default AuthConfiguration;
